import React, { useEffect, useState } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import NavigationTopComponent from "./NavigationTopComponent";
import Cookies from "universal-cookie";

import {
    UserOutlined,
    TrophyOutlined,
    FileTextOutlined,
    BookOutlined,
    FileProtectOutlined,
    FileDoneOutlined,
} from "@ant-design/icons";
import { ConfigProvider, Space, Layout, Menu, theme } from "antd";
const { Content, Footer, Sider } = Layout;

const navSuperAdmin = [
    {
        key: "/course",
        icon: React.createElement(BookOutlined),
        label: <Link to="/course">จัดการคอร์ส</Link>,
    },
    {
        key: "/issue-certificate",
        icon: React.createElement(FileProtectOutlined),
        label: <Link to="/issue-certificate">ออกใบประกาศ</Link>,
    },
    {
        key: "/users/teacher",
        icon: React.createElement(UserOutlined),
        label: <Link to="/users/teacher">รายชื่อผู้สอน</Link>,
    },
    {
        key: "/users/student",
        icon: React.createElement(UserOutlined),
        label: <Link to="/users/student">รายชื่อผู้เรียน</Link>,
    },
];
const navAdmin = [
    {
        key: "/course",
        icon: React.createElement(BookOutlined),
        label: <Link to="/course">ใบประกาศ</Link>,
    },
    {
        key: "/report",
        icon: React.createElement(FileTextOutlined),
        label: <Link to="/report">รายงาน</Link>,
    },
    {
        key: "/users/teacher",
        icon: React.createElement(UserOutlined),
        label: <Link to="/users/teacher">รายชื่อผู้สอน</Link>,
    },
    {
        key: "/users/student",
        icon: React.createElement(UserOutlined),
        label: <Link to="/users/student">รายชื่อผู้เรียน</Link>,
    },
];
const navTeacher = [
    {
        key: "/course",
        icon: React.createElement(BookOutlined),
        label: <Link to="/course">ใบประกาศ</Link>,
    },
    {
        key: "/report",
        icon: React.createElement(FileTextOutlined),
        label: <Link to="/report">รายงาน</Link>,
    },
];
const navStudent = [
    {
        key: "/course",
        icon: React.createElement(BookOutlined),
        label: <Link to="/course">ใบประกาศ</Link>,
    },
    {
        key: "/course_passed",
        icon: React.createElement(FileDoneOutlined),
        label: <Link to="/course_passed">ใบประกาศที่สอบผ่าน</Link>,
    },
    {
        key: "/users/teacher",
        icon: React.createElement(FileProtectOutlined),
        label: <Link to="/certificates">ใบประกาศกิตติคุณ</Link>,
    },
];

const DefaultLayout = ({ cookies, sidebar = true }) => {
    // const auth = cookies.get("authToken");
    const userLoginData = JSON.parse(localStorage.getItem("auth"));
    let navItems = [];
    if (userLoginData) {
        let role = userLoginData.role;
        if (userLoginData.role === "teacher" && userLoginData.is_admin === 1) {
            role = "admin";
        }
        navItems = {
            super_admin: navSuperAdmin,
            admin: navAdmin,
            teacher: navTeacher,
            student: navStudent,
        }[role];
        // console.log(navItems);
    }
    let location = useLocation();

    useEffect(() => {
        console.log(location.pathname);
    }, [location]);

    return (
        <ConfigProvider
            theme={{
                token: {
                    // Seed Token
                    colorPrimary: "#0000FF",
                    borderRadius: 0,

                    // Alias Token
                    colorBgContainer: "#FFFFFF",

                    // Font Family
                    fontFamily: `"Pridi", serif`,
                },
            }}
        >
            <NavigationTopComponent
                colorBackground="#fff"
                colorButton="#0000FF"
                colorButtonText="#fff"
                colorMenu="#0000FF"
                colorBackgroundLogin="#0000FF"
                colorTextLogin="#fff"
                colorBackgroundRegister="#fff"
                colorTextRegister="#0000FF"
                cookies={cookies}
            />

            {sidebar ? (
                // <Layout style={{ minHeight: "100vh", paddingTop: "70px" }}>
                <Layout style={{ minHeight: "100vh" }}>
                    {/* {userLoginData.role !== "super_admin" && ( */}
                    <Sider
                        breakpoint="lg"
                        collapsedWidth="0"
                        onBreakpoint={(broken) => {
                            console.log(broken);
                        }}
                        onCollapse={(collapsed, type) => {
                            console.log(collapsed, type);
                        }}
                        style={{ paddingTop: "0", position: "sticky", top: 0, height: "100vh" }}
                    >
                        <img
                            src="/img/mbog-official-logo.png"
                            alt=""
                            style={{
                                margin: "30px auto 30px",
                                width: "100px",
                                height: "auto",
                                display: "block",
                            }}
                        />
                        <Menu
                            theme="dark"
                            mode="inline"
                            defaultSelectedKeys={[location.pathname]}
                            selectedKeys={[location.pathname]}
                            // items={items}
                            style={{
                                // height: "100%",
                                borderRight: 0,
                            }}
                        >
                            {navItems &&
                                navItems.map((item) => (
                                    <Menu.Item key={item.key}>
                                        {item.icon} {item.label}
                                    </Menu.Item>
                                ))}
                        </Menu>
                    </Sider>
                    {/* )} */}
                    <Layout>
                        <Content style={{ margin: "24px 30px 24px", paddingTop: "70px" }}>
                            <Outlet />
                        </Content>
                        {/* <Footer style={{ textAlign: "center" }}>
                            Ant Design ©{new Date().getFullYear()} Created by MBOG
                        </Footer> */}
                    </Layout>
                </Layout>
            ) : (
                <Outlet />
            )}
        </ConfigProvider>
    );
};
export default DefaultLayout;
